import { theme } from '@theme';
import styled, { keyframes } from 'styled-components';

type DivProps = {
  marginTop?: number;
  marginBottom?: number;
  isPrimaryUser?: boolean;
  isShadowUser?: boolean;
  openedFromModal?: boolean;
  isMobileDevice?: boolean;
};

export const Wrapper = styled.div<DivProps>`
  width: 100% !important;

  .card {
    width: 100%;
    padding: 14px 9px 14px 14px;
    margin: 0 0 9px;
    background: ${theme.palette.white};
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%);
  }

  .card:hover {
    background: ${theme.palette.darkPurpleEUI};
    cursor: pointer;
  }

  .store {
    display: flex;
    align-items: center;
    padding-bottom: ${(props) => (props.isPrimaryUser && !props.isShadowUser ? '4px' : '0')};
    border-bottom: ${(props) =>
      props.isPrimaryUser && !props.isShadowUser
        ? `1px solid ${theme.palette.backgroundGray}`
        : ''};
    height: ${(props) => (props.isPrimaryUser && !props.isShadowUser ? '28px' : 'auto')};
    max-height: 28px;
  }
`;

export const DealerIdsWrappingDiv = styled.div`
  padding-top: 4px;
  color: ${theme.palette.dusty};
  max-width: 405px;
  white-space: normal;
`;

export const TextWrappingDiv = styled.div<DivProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RightAlignedDiv = styled.div`
  margin-left: auto;
`;

export const PrivateIncentiveLookupIconSpan = styled.span`
  margin-right: 5px;
  font-size: 125%;
  vertical-align: sub;
`;

export const StoreHeaderWrapper = styled.div<DivProps>`
  background-color: ${theme.palette.gray};
  position: ${(props) => (props.openedFromModal ? 'inherit' : 'fixed')};
  z-index: 2;
  top: 70px;
  width: 100%;
`;

export const StoreListWrapper = styled.div<DivProps>`
  position: relative;
  margin-top: ${(props) =>
    props.openedFromModal ? 0 : props.isPrimaryUser && !props.isShadowUser ? '160px' : '95px'};
  background-color: ${(props) => (props.openedFromModal ? theme.palette.gray : '')};
`;

export const LoadingWrapper = styled.div<DivProps>`
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 100%;
  gap: 30px;
  padding-top: ${(props) => (props.openedFromModal ? '0' : '70px')};
  height: ${(props) => (props.openedFromModal ? '600px' : '0')};
`;

const dots = keyframes`
  0%, 20% {
    color: rgba(102, 102, 102, 0);
    text-shadow: 0.25em 0 0 rgba(102, 102, 102, 0), 0.5em 0 0 rgba(102, 102, 102, 0);
  }
  40% {
    color: #676767;
    text-shadow: 0.25em 0 0 rgba(102, 102, 102, 0), 0.5em 0 0 rgba(102, 102, 102, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 #676767, 0.5em 0 0 rgba(102, 102, 102, 0);
  }
  80%, 100% {
    text-shadow: 0.25em 0 0 #676767, 0.5em 0 0 #676767;
  }
`;

const glow = keyframes`
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
`;

export const CenterAlignedDiv = styled.div<DivProps>`
  width: 100%;
  text-align: center;
  margin-top: ${(props) => props.marginTop ?? 0}px;
  margin-bottom: ${(props) => props.marginBottom ?? 0}px;
`;

export const LineHeightDiv = styled.div`
  line-height: 1.1;
`;

export const SearchDiv = styled.div<DivProps>`
  width: 100%;
  max-width: 393px;
  margin: 0 auto;
  padding: ${(props) => (props.isPrimaryUser && !props.isShadowUser ? '0 0 20px' : '0')};
  position: relative;
  .input-group-prepend {
    font-size: 130%;
    position: absolute;
    top: 8px;
    left: 17px;
    color: ${theme.palette.dusty};
    z-index: 4;
  }
  .search {
    width: 100%;
    padding-left: 47px;
  }

  ${(props) =>
    props.isMobileDevice &&
    `
        padding: 0 1.6rem;

        .input-group-prepend {
            padding-left: 1rem;
        }
    `}
`;

export const InactiveDealerInput = styled.input`
  cursor: pointer;
`;

export const ResultsDiv = styled.div<DivProps>`
  width: 100%;
  max-width: 393px;
  margin: 0 auto;
  padding: 2px 1px 0;
  position: relative;
  height: ${(props) => (props.openedFromModal ? '440px' : '')};
  overflow-y: ${(props) => (props.openedFromModal ? 'auto' : '')};
  overflow-x: ${(props) => (props.openedFromModal ? 'hidden' : '')};

  ${(props) =>
    props.isMobileDevice &&
    `
      padding: 0.8rem 1.6rem 1rem
    `}
`;

export const BadgerDiv = styled.div<DivProps>`
  width: 100% !important;
  height: ${(props) => (props.openedFromModal ? '440px' : '')};
  .badger {
    position: fixed;
    top: ${(props) => (props.openedFromModal ? '40%' : '50%')};
    left: 45%;
  }
  .badger:hover {
    animation-name: shake-hard;
    animation-duration: 400ms;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }
`;

export const ShowInactiveLabel = styled.label`
  cursor: pointer;
`;

export const ShowCloseIcon = styled.div`
  cursor: pointer;

  .store-select-close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    opacity: 0.4;
    font-size: 185%;
    font-weight: ${theme.typography.fontWeights.bold};
  }
  .store-select-close-icon:hover {
    opacity: 0.8;
  }
`;
